import { run, eraseCookies, acceptedCategory, validConsent, show, showPreferences } from 'vanilla-cookieconsent'
import 'vanilla-cookieconsent/dist/cookieconsent.css'

let isInitialized = false

document.addEventListener('turbolinks:load', () => {
  updateConsentBlocks()
  initCookieConsent()
})

const cookieConsentConfig = {
  root: document.documentElement,
  guiOptions: {
    consentModal: {
      equalWeightButtons: false,
      position: 'bottom left',
    },
    preferencesModal: {
      equalWeightButtons: true,
    },
  },
  revision: 0,
  categories: {
    necessary: {
      readOnly: true,
    },
    functional: {},
    third_party: {},
  },
  language: {
    default: 'en',
    autoDetect: 'document',
    translations: {
      en: {
        consentModal: {
          title: 'Cookies and similar technologies',
          description:
            'We use cookies and similar technologies to operate our website, ensure security, and provide certain features. With your consent, we also use optional cookies for enhanced functionality and external content.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences',
        },
        preferencesModal: {
          title: 'Preferences for cookies and similar technologies',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close',
          sections: [
            {
              description: `
                  <p class="d-block">
                    We use cookies and similar technologies to operate our website, ensure security, and provide certain features. With your consent, we also use optional cookies for enhanced functionality and external content.
                  </p>
                  <p class="d-block mt-3">
                    Please use the toggles below to customize your preferences.
                  </p>
                  `,
            },
            {
              title: 'Essential <span class="pm__badge">Always Enabled</span>',
              description: 'These cookies are always active and necessary for our website to function properly.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Functional',
              description: `
                <p>
                  These cookies enable additional features that enhance your experience on our website. Examples include:
                </p>
                <ul>
                  <li>
                    Remembering your login session (“Remember me”)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'External content',
              description: `
                <p>
                  These services load content from external providers. Examples include:
                </p>
                <ul>
                  <li>
                    Google Charts (data visualization)
                  </li>
                  <li>
                    OpenStreetMap (tile image data for geographic maps)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      de: {
        consentModal: {
          title: 'Cookies und ähnliche Technologien',
          description:
            'Wir verwenden Cookies und ähnliche Technologien, um unsere Website zu betreiben, die Sicherheit zu gewährleisten und bestimmte Funktionen bereitzustellen. Mit Ihrer Einwilligung verwenden wir außerdem optionale Cookies für erweiterte Funktionalität und externe Inhalte.',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Alle ablehnen',
          showPreferencesBtn: 'Einstellungen verwalten',
        },
        preferencesModal: {
          title: 'Einstellungen für Cookies und ähnliche Technologien',
          acceptAllBtn: 'Alle akzeptieren',
          acceptNecessaryBtn: 'Alle ablehnen',
          savePreferencesBtn: 'Einstellungen speichern',
          closeIconLabel: 'Schließen',
          sections: [
            {
              description: `
                  <p class="d-block">
                    Wir verwenden Cookies und ähnliche Technologien, um unsere Website zu betreiben, die Sicherheit zu gewährleisten und bestimmte Funktionen bereitzustellen. Mit Ihrer Einwilligung verwenden wir außerdem optionale Cookies für erweiterte Funktionalität und externe Inhalte.
                  </p>
                  <p class="d-block mt-3">
                    Bitte verwenden Sie die Schalter unten, um Ihre Einstellungen anzupassen.
                  </p>
                  `,
            },
            {
              title: 'Essentiell <span class="pm__badge">Immer aktiv</span>',
              description:
                'Diese Cookies sind immer aktiv und erforderlich, damit unsere Website ordnungsgemäß funktioniert.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Funktional',
              description: `
                <p>
                  Diese Cookies ermöglichen zusätzliche Funktionen, die Ihr Nutzungserlebnis auf unserer Website verbessern. Beispiele:
                </p>
                <ul>
                  <li>
                    Merken Ihrer Anmeldesitzung („Angemeldet bleiben“)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Externe Inhalte',
              description: `
                <p>
                  Diese Dienste laden Inhalte von externen Anbietern. Beispiele:
                </p>
                <ul>
                  <li>
                    Google Charts (Datenvisualisierung)
                  </li>
                  <li>
                    OpenStreetMap (Kachelbilddaten für geografische Karten)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      nl: {
        consentModal: {
          title: 'Cookies en vergelijkbare technologieën',
          description:
            'We gebruiken cookies en vergelijkbare technologieën om onze website te laten werken, de veiligheid te waarborgen en bepaalde functies aan te bieden. Met uw toestemming gebruiken we ook optionele cookies voor extra functionaliteit en externe inhoud.',
          acceptAllBtn: 'Alles accepteren',
          acceptNecessaryBtn: 'Alles weigeren',
          showPreferencesBtn: 'Voorkeuren beheren',
        },
        preferencesModal: {
          title: 'Voorkeuren voor cookies en vergelijkbare technologieën',
          acceptAllBtn: 'Alles accepteren',
          acceptNecessaryBtn: 'Alles weigeren',
          savePreferencesBtn: 'Voorkeuren opslaan',
          closeIconLabel: 'Sluiten',
          sections: [
            {
              description: `
                  <p class="d-block">
                    We gebruiken cookies en vergelijkbare technologieën om onze website te laten werken, de veiligheid te waarborgen en bepaalde functies aan te bieden. Met uw toestemming gebruiken we ook optionele cookies voor extra functionaliteit en externe inhoud.
                  </p>
                  <p class="d-block mt-3">
                    Gebruik de schakelaars hieronder om uw voorkeuren aan te passen.
                  </p>
                  `,
            },
            {
              title: 'Essentieel <span class="pm__badge">Altijd ingeschakeld</span>',
              description:
                'Deze cookies zijn altijd actief en noodzakelijk om onze website correct te laten functioneren.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Functioneel',
              description: `
                <p>
                  Deze cookies maken extra functies mogelijk die uw ervaring op onze website verbeteren. Voorbeelden zijn:
                </p>
                <ul>
                  <li>
                    Uw aanmeldsessie onthouden („Onthoud mij“)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Externe inhoud',
              description: `
                <p>
                  Deze diensten laden inhoud van externe aanbieders. Voorbeelden zijn:
                </p>
                <ul>
                  <li>
                    Google Charts (datavisualisatie)
                  </li>
                  <li>
                    OpenStreetMap (tegelafbeeldingen voor geografische kaarten)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      fr: {
        consentModal: {
          title: 'Cookies et technologies similaires',
          description:
            'Nous utilisons des cookies et des technologies similaires pour faire fonctionner notre site, garantir la sécurité et fournir certaines fonctionnalités. Avec votre consentement, nous utilisons également des cookies optionnels pour des fonctionnalités améliorées et des contenus externes.',
          acceptAllBtn: 'Tout accepter',
          acceptNecessaryBtn: 'Tout refuser',
          showPreferencesBtn: 'Gérer les préférences',
        },
        preferencesModal: {
          title: 'Préférences pour les cookies et technologies similaires',
          acceptAllBtn: 'Tout accepter',
          acceptNecessaryBtn: 'Tout refuser',
          savePreferencesBtn: 'Enregistrer les préférences',
          closeIconLabel: 'Fermer',
          sections: [
            {
              description: `
                  <p class="d-block">
                    Nous utilisons des cookies et des technologies similaires pour faire fonctionner notre site, garantir la sécurité et fournir certaines fonctionnalités. Avec votre consentement, nous utilisons également des cookies optionnels pour des fonctionnalités améliorées et des contenus externes.
                  </p>
                  <p class="d-block mt-3">
                    Utilisez les interrupteurs ci-dessous pour personnaliser vos préférences.
                  </p>
                  `,
            },
            {
              title: 'Essentiel <span class="pm__badge">Toujours activé</span>',
              description: 'Ces cookies sont toujours actifs et nécessaires au bon fonctionnement de notre site.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Fonctionnel',
              description: `
                <p>
                  Ces cookies permettent des fonctionnalités supplémentaires qui améliorent votre expérience sur notre site. Exemples :
                </p>
                <ul>
                  <li>
                    Mémoriser votre session de connexion (« Se souvenir de moi »)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Contenu externe',
              description: `
                <p>
                  Ces services chargent du contenu provenant de fournisseurs externes. Exemples :
                </p>
                <ul>
                  <li>
                    Google Charts (visualisation de données)
                  </li>
                  <li>
                    OpenStreetMap (images de tuiles pour cartes géographiques)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      es: {
        consentModal: {
          title: 'Cookies y tecnologías similares',
          description:
            'Usamos cookies y tecnologías similares para operar nuestro sitio web, garantizar la seguridad y ofrecer ciertas funciones. Con su consentimiento, también usamos cookies opcionales para una funcionalidad mejorada y contenido externo.',
          acceptAllBtn: 'Aceptar todo',
          acceptNecessaryBtn: 'Rechazar todo',
          showPreferencesBtn: 'Gestionar preferencias',
        },
        preferencesModal: {
          title: 'Preferencias para cookies y tecnologías similares',
          acceptAllBtn: 'Aceptar todo',
          acceptNecessaryBtn: 'Rechazar todo',
          savePreferencesBtn: 'Guardar preferencias',
          closeIconLabel: 'Cerrar',
          sections: [
            {
              description: `
                  <p class="d-block">
                    Usamos cookies y tecnologías similares para operar nuestro sitio web, garantizar la seguridad y ofrecer ciertas funciones. Con su consentimiento, también usamos cookies opcionales para una funcionalidad mejorada y contenido externo.
                  </p>
                  <p class="d-block mt-3">
                    Use los interruptores a continuación para personalizar sus preferencias.
                  </p>
                  `,
            },
            {
              title: 'Esencial <span class="pm__badge">Siempre activado</span>',
              description:
                'Estas cookies siempre están activas y son necesarias para que nuestro sitio web funcione correctamente.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Funcional',
              description: `
                <p>
                  Estas cookies permiten funciones adicionales que mejoran su experiencia en nuestro sitio web. Ejemplos:
                </p>
                <ul>
                  <li>
                    Recordar su sesión de inicio de sesión (« Recuérdame »)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Contenido externo',
              description: `
                <p>
                  Estos servicios cargan contenido de proveedores externos. Ejemplos:
                </p>
                <ul>
                  <li>
                    Google Charts (visualización de datos)
                  </li>
                  <li>
                    OpenStreetMap (imágenes de teselas para mapas geográficos)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      pl: {
        consentModal: {
          title: 'Pliki cookie i podobne technologie',
          description:
            'Używamy plików cookie i podobnych technologii, aby obsługiwać naszą stronę, zapewnić bezpieczeństwo i udostępniać niektóre funkcje. Za Twoją zgodą używamy także opcjonalnych plików cookie w celu zapewnienia dodatkowych funkcji i treści zewnętrznych.',
          acceptAllBtn: 'Akceptuj wszystkie',
          acceptNecessaryBtn: 'Odrzuć wszystkie',
          showPreferencesBtn: 'Zarządzaj preferencjami',
        },
        preferencesModal: {
          title: 'Preferencje dotyczące plików cookie i podobnych technologii',
          acceptAllBtn: 'Akceptuj wszystkie',
          acceptNecessaryBtn: 'Odrzuć wszystkie',
          savePreferencesBtn: 'Zapisz preferencje',
          closeIconLabel: 'Zamknij',
          sections: [
            {
              description: `
                  <p class="d-block">
                    Używamy plików cookie i podobnych technologii, aby obsługiwać naszą stronę, zapewnić bezpieczeństwo i udostępniać niektóre funkcje. Za Twoją zgodą używamy także opcjonalnych plików cookie w celu zapewnienia dodatkowych funkcji i treści zewnętrznych.
                  </p>
                  <p class="d-block mt-3">
                    Użyj przełączników poniżej, aby dostosować swoje preferencje.
                  </p>
                  `,
            },
            {
              title: 'Niezbędne <span class="pm__badge">Zawsze włączone</span>',
              description: 'Te pliki cookie są zawsze aktywne i niezbędne do prawidłowego działania naszej strony.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Funkcjonalne',
              description: `
                <p>
                  Te pliki cookie umożliwiają dodatkowe funkcje, które poprawiają komfort korzystania z naszej strony. Przykłady:
                </p>
                <ul>
                  <li>
                    Zapamiętywanie sesji logowania („Zapamiętaj mnie“)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Treści zewnętrzne',
              description: `
                <p>
                  Te usługi wczytują treści od zewnętrznych dostawców. Przykłady:
                </p>
                <ul>
                  <li>
                    Google Charts (wizualizacja danych)
                  </li>
                  <li>
                    OpenStreetMap (obrazy kafelków dla map geograficznych)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
      fi: {
        consentModal: {
          title: 'Evästeet ja vastaavat teknologiat',
          description:
            'Käytämme evästeitä ja vastaavia teknologioita verkkosivustomme toiminnan varmistamiseksi, turvallisuuden takaamiseksi ja tiettyjen ominaisuuksien tarjoamiseksi. Suostumuksellasi käytämme myös valinnaisia evästeitä parannettuihin toimintoihin ja ulkoiseen sisältöön.',
          acceptAllBtn: 'Hyväksy kaikki',
          acceptNecessaryBtn: 'Hylkää kaikki',
          showPreferencesBtn: 'Hallitse asetuksia',
        },
        preferencesModal: {
          title: 'Asetukset evästeille ja vastaaville teknologioille',
          acceptAllBtn: 'Hyväksy kaikki',
          acceptNecessaryBtn: 'Hylkää kaikki',
          savePreferencesBtn: 'Tallenna asetukset',
          closeIconLabel: 'Sulje',
          sections: [
            {
              description: `
                  <p class="d-block">
                    Käytämme evästeitä ja vastaavia teknologioita verkkosivustomme toiminnan varmistamiseksi, turvallisuuden takaamiseksi ja tiettyjen ominaisuuksien tarjoamiseksi. Suostumuksellasi käytämme myös valinnaisia evästeitä parannettuihin toimintoihin ja ulkoiseen sisältöön.
                  </p>
                  <p class="d-block mt-3">
                    Käytä alla olevia valintoja muokataksesi asetuksiasi.
                  </p>
                  `,
            },
            {
              title: 'Välttämättömät <span class="pm__badge">Aina käytössä</span>',
              description: 'Nämä evästeet ovat aina aktiivisia ja välttämättömiä, jotta sivustomme toimii oikein.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Toiminnalliset',
              description: `
                <p>
                  Nämä evästeet mahdollistavat lisäominaisuuksia, jotka parantavat käyttökokemustasi sivustollamme. Esimerkiksi:
                </p>
                <ul>
                  <li>
                    Kirjautumisistuntosi muistaminen (”Muista minut”)
                  </li>
                </ul>`,
              linkedCategory: 'functional',
            },
            {
              title: 'Ulkoinen sisältö',
              description: `
                <p>
                  Nämä palvelut lataavat sisältöä ulkoisilta palveluntarjoajilta. Esimerkiksi:
                </p>
                <ul>
                  <li>
                    Google Charts (datan visualisointi)
                  </li>
                  <li>
                    OpenStreetMap (karttojen laatta-/tiilikuva-aineisto)
                  </li>
                </ul>`,
              linkedCategory: 'third_party',
            },
          ],
        },
      },
    },
  },
}

async function initCookieConsent() {
  if (!isInitialized) {
    run({
      ...cookieConsentConfig,
      onChange: () => {
        manageRememberMeFunctionality()
        updateConsentBlocks()
        window.dispatchEvent(new CustomEvent('consent:update'))
      },
      onConsent: () => {
        manageRememberMeFunctionality()
        updateConsentBlocks()
        window.dispatchEvent(new CustomEvent('consent:update'))
      },
    })
    // remove legacy cookie that was used by old cookie consent implementation
    // can be removed after 1 year after deployment since the expiry of this cookie was set to 1 year
    eraseCookies('cookies-state')
  }
  isInitialized = true

  if (!validConsent()) {
    show(true) // pass true to force modal show
  }

  $('[data-cc="show-preferencesModal"]').on('click', (e) => {
    // on full reload of page there is existing click event via consentmanager
    // on turbolinks load there is not, therefore needs to be added
    e.preventDefault()
    e.stopImmediatePropagation()
    showPreferences(true)
  })
}

// Unless user the consents to the "functional" category, the "keep me logged in"
// functionality should not be shown since it relies on cookies to work
// and it is legally not considered strictly necessary
function manageRememberMeFunctionality() {
  const rememberMeCheckbox = document.querySelector('#remember-me-field')
  if (!rememberMeCheckbox) return

  if (acceptedCategory('functional')) {
    rememberMeCheckbox.classList.remove('d-none')
  } else {
    rememberMeCheckbox.classList.add('d-none')
  }
}

export function showCookiePreferences() {
  showPreferences()
}

// View handling for _consent_gated_content partial: Show/hide content based on consent category
function updateConsentBlocks() {
  document.querySelectorAll('[data-consent-category]').forEach(function (el) {
    const category = el.dataset.consentCategory
    const allowed = acceptedCategory(category)

    const fallback = el.querySelector('.consent-fallback')
    const content = el.querySelector('.consent-content')

    if (!fallback || !content) return

    if (allowed) {
      fallback.style.display = 'none'
      content.style.display = ''
    } else {
      fallback.style.display = ''
      content.style.display = 'none'
    }
  })
}

export function hasConsentCategory(category) {
  try {
    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith('cc_cookie='))
      ?.split('=')[1]

    if (!cookie) return false

    const data = JSON.parse(decodeURIComponent(cookie))

    return Array.isArray(data.categories) && data.categories.includes(category)
  } catch (err) {
    console.error('Failed to check consent category:', err)
    return false
  }
}
